import { render, staticRenderFns } from "./translatorPrint.vue?vue&type=template&id=bcb970e2&scoped=true&"
import script from "./translatorPrint.vue?vue&type=script&lang=js&"
export * from "./translatorPrint.vue?vue&type=script&lang=js&"
import style0 from "./translatorPrint.vue?vue&type=style&index=0&id=bcb970e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb970e2",
  null
  
)

export default component.exports